import React from 'react'
import { Typography, Button, Grid } from '@mui/material';
import colors from '../../colors'
import Card from '@mui/material/Card';
import LatestTransactions from './latesetTransactions/LatestTransactions'
import { ReactComponent as IconPaguajDashboard } from '../../../icons/payMoney.svg';
import { ReactComponent as IconDergoParaBasicDashboard } from '../../../icons/SendMoneyBasic.svg';
import Lottie from "lottie-react";
import spaceshipAnimation from '../../../icons/lottieAnimations/spaceship.json'
import Skeleton from '@material-ui/lab/Skeleton';
import FinishRegistration from '../../registration/registrationSteps/FinishRegistration';
import { texts } from '../../general/texts';
import News from './news/News';
import DashboardSection from '../inviteFriend/DashboardSection';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';

export const BasicAccountDashboard = (props) => {

    const classes = props.classes
    const userInfo = useSelector(selectUserInfo);
    const [isSectionRemoved, setIsSectionRemoved] = useState(false) 

    const handleSectionRemove = () => {
        setIsSectionRemoved(JSON.parse(localStorage.getItem('removeIFSection')) || false)
    };

    const [isOpen, setIsOpen] = React.useState(false);

    const handleOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Grid container spacing={'5%'} >
            <Grid container item md={6} xs={12} justifyContent={'right'} rowSpacing={'4%'}  >
                {props.userInfo.shouldDisplayWelcomeCard &&
                    <Grid container item ref={props.spaceshipCardGrid} md={12} xs={12} justifyContent={'right'} className={classes.spaceshipCardGrid}  >
                        <Card elevation={3} className={classes.purpleCard}  >
                            <Grid container item md={12} xs={12} justifyContent={'right'} >
                                <Button sx={{ color: colors.white, borderRadius: '10px' }} onClick={() => { props.spaceshipCardGrid.current.style.display = "none" }} >X</Button>
                            </Grid>
                            <Grid container item md={12} xs={12} pl={'3%'} >
                                <Grid item md={2.5} xs={2.5} >
                                    <Lottie animationData={spaceshipAnimation} loop={true} autoplay={true} />
                                </Grid>
                                <Grid item md={8} xs={8} pl={'3%'}>
                                    <Typography className={classes.spaceshipCardGridTitle} >{texts["message-welcome"]}</Typography>
                                    <Typography className={classes.spaceshipCardGridText} >{texts["message-welcoming-info"]}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item md={12} xs={12} justifyContent={'right'} pr={'5%'} pb={'3%'} >
                                <Button sx={{ color: colors.white, fontSize: '0.8rem', textTransform: 'none', fontFamily: 'GerberaLight', borderRadius: '20px' }} >{texts["show-me-how"]}</Button>
                            </Grid>
                        </Card>
                    </Grid>
                }
                <Grid container item md={12} xs={12} mt={'8%'} justifyContent={'right'} sx={{ '@media (max-width: 899px)': { justifyContent: 'center' } }} >
                    <Grid sx={{ width: '60%', background: colors.cyan, '@media (max-width: 1440px)': { width: '80%' }, '@media (max-width: 899px)': { width: '90%' } }}>
                        <Grid container item md={12} xs={12} justifyContent={'center'} >
                            <Grid container item md={6} sm={6} xs={6} justifyContent={'center'} alignItems={'center'} direction={'column'} >
                                <Button disableRipple={true} onClick={() => { props.navigate('/onpayments') }} className={classes.iconButton} >
                                    <IconPaguajDashboard />
                                </Button>
                                <Typography textAlign={'center'} className={classes.iconButtonTitle} >{texts["title-pay"]}</Typography>
                            </Grid>
                            <Grid container item md={6} sm={6} xs={6} justifyContent={'center'} alignItems={'center'} direction={'column'} >
                                <Button disableRipple={true} onClick={() => handleOpen()} className={classes.iconButton} >
                                    <IconDergoParaBasicDashboard />
                                </Button>
                                <Typography textAlign={'center'} className={classes.iconButtonTitle}>{texts["button-send"]}</Typography>
                            </Grid>
                            {/* <Grid item md={4} xs={4}>
                            <Button disableRipple={true} onClick={() => handleOpen()} className={classes.iconButton} >
                                <IconKerkoParaBasicDashboard  />
                            </Button>
                            <Typography className={classes.iconButtonTitle}>Kërko Para</Typography>
                        </Grid> */}
                        </Grid>
                    </Grid>
                    {(!isSectionRemoved && userInfo.showInviteFriend) && (
                        <DashboardSection onRemoveSection={handleSectionRemove}/>
                    )}
                </Grid>
                {/* <Grid item container md={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                <Card elevation={3} className={classes.lastCard} >
                    <Grid container item md={11} xs={11} mt={'2%'} justifyContent={'right'}>
                        <LockerIcon />
                    </Grid>
                    <Grid container item md={12} mt={'-3%'} >
                        <Grid item md={2} xs={2} justifyContent={'left'}   pl={'3%'} >
                            <IconRuaniPagesa width={'100%'} />
                        </Grid>
                        <Grid item md={9} xs={9} pl={'5%'} pt={'7%'} >
                            <Typography textAlign={'left'} sx={{color:colors.darkBlue, fontSize:'1rem' ,fontFamily:'GerberaLight'}} >
                                Këtu mund të ruani shërbime apo llojet e pagesave që kryeni me EasyPay
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item container md={12} xs={12} justifyContent={'right'} pr={'7%'} marginTop={'-6%'}  pb={'3%'} >
                        <Button onClick={() => handleOpen()} sx={{color:colors.orange,fontFamily:'GerberaLight', fontSize:'0.8rem', borderRadius:'20px', textTransform: 'none' , ":hover":{backgroundColor:colors.white, textTransform:'none', ":hover":{background:colors.gradientOrange, color:colors.white}}}} >Më trego si</Button>
                    </Grid>
                </Card>
            </Grid> */}
            </Grid>
            <Grid container item md={6} xs={12} justifyContent={'left'} sx={{ '@media (max-width: 899px)': { justifyContent: 'center' } }}  >
                <Grid container item md={7} xs={12} justifyContent={{ md: 'left', xs: 'center' }} style={{marginBottom: props.userInfo.news?.length > 0 ? '50px' : '0' }}>
                    {props.userInfo.isLoading ? (<Skeleton variant="rect" width={'60%'} height={'350px'} />) : (props.userInfo.news?.length === 0 ? null : <News classes={classes} news={props.userInfo.news} />)}
                </Grid>
                {props.userInfo.isLoading ? <Skeleton variant="rect" width={'60%'} height={'350px'} /> : <LatestTransactions latestTransactions={props.userInfo.latestTransactions} />}
            </Grid>
            <FinishRegistration isDialogOpened={isOpen} handleCloseDialog={() => setIsOpen(false)} />
        </Grid>
    )
}
export default BasicAccountDashboard